import { Navigate } from '@sorare/routing';

const HomePage = () => {
  return <Navigate to="classic" replace keepSearchParams />;
};

export default HomePage;
